import Reveal from '../components/Reveal';
import { COMPANY } from '../data';

const CONTACT_INFO = [
  { icon: '📞', label: 'Phone / WhatsApp', value: COMPANY.phone, href: COMPANY.whatsapp },
  { icon: '✉️', label: 'Email',            value: COMPANY.email, href: `mailto:${COMPANY.email}` },
  { icon: '📍', label: 'Address',          value: COMPANY.address },
  { icon: '🕐', label: 'Operating Hours',  value: COMPANY.hours  },
];

const SOCIAL_LINKS = [
  { label: 'Instagram', icon: '📸', href: COMPANY.social.instagram, color: '#E1306C',  desc: '@neuralmediasolutions' },
  { label: 'Facebook',  icon: '👥', href: COMPANY.social.facebook,  color: '#1877F2',  desc: 'Neural Media Solutions' },
  { label: 'LinkedIn',  icon: '💼', href: COMPANY.social.linkedin,  color: '#0A66C2',  desc: 'Neural Media Solutions' },
  { label: 'WhatsApp',  icon: '💬', href: COMPANY.social.whatsapp,  color: '#25D366',  desc: '+91 72900 66328' },
  { label: 'Meta',      icon: '🔵', href: COMPANY.social.meta || COMPANY.social.facebook, color: '#0668E1', desc: 'Meta Business Page' },
];

export default function Contact({ openForm }) {
  return (
    <div style={{ paddingTop: 90 }}>
      <section className="section">
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.3fr', gap: 64, alignItems: 'start' }}>

            {/* ── Left: contact info ── */}
            <Reveal>
              <span className="tag">Get In Touch</span>
              <h1 style={{ fontFamily: 'var(--fD)', fontSize: 'clamp(28px,4vw,52px)', fontWeight: 900, lineHeight: 1.05, marginBottom: 18 }}>
                Let's grow your<br />real estate business.
              </h1>
              <p style={{ color: 'var(--mut)', fontSize: 16, lineHeight: 1.8, marginBottom: 36 }}>
                Tell us about your project. We'll come back with a clear strategy for generating qualified inquiries — free.
              </p>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 18, marginBottom: 36 }}>
                {CONTACT_INFO.map((item, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
                    <div style={{ width: 42, height: 42, background: 'var(--surf)', border: '1px solid var(--bdr)', borderRadius: 11, display: 'grid', placeItems: 'center', fontSize: 18, flexShrink: 0 }}>{item.icon}</div>
                    <div>
                      <div style={{ color: 'var(--mut)', fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 3 }}>{item.label}</div>
                      {item.href
                        ? <a href={item.href} target="_blank" rel="noreferrer" style={{ fontWeight: 600, fontSize: 15, color: 'var(--txt)', textDecoration: 'none' }}>{item.value}</a>
                        : <div style={{ fontWeight: 600, fontSize: 15 }}>{item.value}</div>
                      }
                    </div>
                  </div>
                ))}
              </div>

              {/* Social Media Links */}
              <div style={{ marginBottom: 24 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--mut)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 16 }}>
                  Connect With Us
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {SOCIAL_LINKS.map(s => (
                    <a
                      key={s.label}
                      href={s.href}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        display: 'flex', alignItems: 'center', gap: 14,
                        padding: '12px 16px',
                        background: 'var(--surf)',
                        border: '1px solid var(--bdr)',
                        borderRadius: 12,
                        textDecoration: 'none',
                        transition: 'all 0.2s',
                      }}
                      onMouseOver={e => { e.currentTarget.style.borderColor = s.color + '55'; e.currentTarget.style.background = s.color + '12'; }}
                      onMouseOut={e  => { e.currentTarget.style.borderColor = 'var(--bdr)'; e.currentTarget.style.background = 'var(--surf)'; }}
                    >
                      <div style={{ width: 36, height: 36, background: s.color + '20', borderRadius: 9, display: 'grid', placeItems: 'center', fontSize: 18, flexShrink: 0 }}>
                        {s.icon}
                      </div>
                      <div>
                        <div style={{ fontWeight: 700, fontSize: 14, color: 'var(--txt)' }}>{s.label}</div>
                        <div style={{ fontSize: 12, color: 'var(--mut)' }}>{s.desc}</div>
                      </div>
                      <span style={{ marginLeft: 'auto', color: 'var(--mut)', fontSize: 18 }}>→</span>
                    </a>
                  ))}
                </div>
              </div>

              <a
                href={COMPANY.whatsapp}
                target="_blank"
                rel="noreferrer"
                style={{ display: 'inline-flex', alignItems: 'center', gap: 10, background: '#25D366', color: '#fff', padding: '15px 26px', borderRadius: 11, fontWeight: 700, fontSize: 16, textDecoration: 'none' }}
              >
                💬 Chat on WhatsApp
              </a>
            </Reveal>

            {/* ── Right: form prompt card ── */}
            <Reveal delay={0.15}>
              <div style={{ background: 'var(--surf)', border: '1px solid var(--bdr)', borderRadius: 22, padding: 44, textAlign: 'center' }}>
                <div style={{ fontSize: 52, marginBottom: 16 }}>📋</div>
                <h2 style={{ fontFamily: 'var(--fD)', fontWeight: 900, fontSize: 24, marginBottom: 12 }}>Start Free Consultation</h2>
                <p style={{ color: 'var(--mut)', fontSize: 15, lineHeight: 1.75, marginBottom: 30 }}>
                  Takes 2 minutes. Tell us about your project and we'll respond with a custom strategy within 24 hours.
                </p>
                <button
                  onClick={openForm}
                  className="btn btn-teal"
                  style={{ width: '100%', justifyContent: 'center', fontSize: 16, padding: '15px 24px', marginBottom: 16 }}
                >
                  Fill Our Enquiry Form →
                </button>
                <div style={{ display: 'flex', gap: 12, justifyContent: 'center', color: 'var(--mut)', fontSize: 12, flexWrap: 'wrap' }}>
                  <span>🔒 100% Private</span>
                  <span>·</span>
                  <span>⚡ 24hr Response</span>
                  <span>·</span>
                  <span>💬 WhatsApp Follow-up</span>
                </div>
              </div>

              {/* Map embed placeholder */}
              <div style={{ marginTop: 24, background: 'var(--surf)', border: '1px solid var(--bdr)', borderRadius: 18, overflow: 'hidden' }}>
                <iframe
                  title="Neural Media Solutions Location"
                  width="100%"
                  height="240"
                  loading="lazy"
                  style={{ border: 0, display: 'block' }}
                  src="https://maps.google.com/maps?q=Raj+Nagar+Extension,+Ghaziabad,+UP+201003&output=embed"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
